<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    @close="hideModal"
  >
    <el-form
      class="object-creater-form"
      ref="objectCreaterForm"
      :rules="rules"
      :model="object"
      :validateOnRuleChange="false"
    >
      <h3 class="object-creater-form__title">
        {{ $t("object_create_form_title") }}
      </h3>

      <el-form-item
        class="object-creater-form__item"
        :label="$t('object_create_form_type')"
        prop="objType"
      >
        <el-select v-model="object.objType" filterable>
          <el-option
            v-for="item in objectTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        class="object-creater-form__item"
        :label="$t('object_create_form_name')"
        prop="name"
      >
        <el-input
          class="show-word-limit-pad"
          v-model="object.name"
          maxlength="500"
          show-word-limit
          autofocus
        ></el-input>
      </el-form-item>

      <el-form-item
        class="object-creater-form__item"
        :label="$t('object_create_form_country')"
        prop="countryId"
      >
        <el-select
          v-model="object.countryId"
          filterable
          @change="changeCountry"
        >
          <el-option
            v-for="item in countries"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        class="object-creater-form__item"
        :label="$t('object_create_form_city')"
        prop="cityId"
      >
        <el-select v-model="object.cityId" filterable @change="changeCity">
          <el-option
            v-for="item in cityRef"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        class="object-creater-form__item object-creater-form__action"
      >
        <el-button @click="hideModal">
          {{ $t("object_create_form_cancel") }}
        </el-button>

        <el-button type="success" @click="submitForm('objectCreaterForm')">
          {{ $t("object_create_form_create") }}
        </el-button>
      </el-form-item>
    </el-form>
  </app-modal>
</template>

<script>
export default {
  name: "ObjectCreater",
  components: {
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    countries: Array,
    cities: Array,
    objectTypes: Array
  },
  data() {
    return {
      object: {
        name: "",
        objType: undefined,
        countryId: undefined,
        cityId: undefined
      },
      rules: {
        objType: [
          {
            required: true,
            message: this.$t("object_create_form_type_rule"),
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t("object_create_form_name_rule"),
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    cityRef() {
      if (this.object.countryId) {
        return this.cities.filter(
          item => item.countryId === this.object.countryId
        );
      }
      return this.cities;
    }
  },
  methods: {
    changeCity() {
      if (!this.object.countryId) {
        let item = this.cityRef.find(c => c.id === this.object.cityId);
        if (item) {
          this.object.countryId = item.countryId;
        }
      }
    },
    changeCountry() {
      if (this.object.cityId) {
        if (!this.cityRef.some(c => c.id === this.object.cityId)) {
          this.object.cityId = undefined;
        }
      }
    },
    hideModal() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.object);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
          this.hideModal();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.object-creater-form {
  .object-creater-form__title {
    text-align: left;
    padding: $form_title_padding;
  }

  .object-creater-form__item {
    padding: $form_item_padding;
  }

  .object-creater-form__action {
    text-align: right;
  }
}
</style>
